module.exports = __webpack_public_path__ + "img/azc_logo.4c7ca538.png";